import React, { useEffect, useState, useMemo, useRef } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { TableContainer } from "@mui/material";
import { Icon } from '@iconify/react';
import { StonePopUpFields } from 'Components/Pages/Gdev/Trading/Popup';
import { toPlainFields } from 'Components/Pages/Gdev/Trading/fieldconverter';
import Select, { components } from 'react-select';

const SingleStonePopUp = ({ itemlist, addStone, index, onClose, onSave, stonemaster }) => {

  const [currentFieldIndex, setCurrentFieldIndex] = useState(0); // Track the index of the current field
  const inputRefs = useRef([]); // Store references for each input field

  const localfields = useMemo(() => toPlainFields(StonePopUpFields), []);

  const [itemfields, setItemfields] = useState(() => {
    // Initialize fields with defaults
    const updatedFields = localfields.map((localField) => ({
      ...localField,
      value: "", // Initialize value as empty string
      label: localField.label || "Default Label",
      placeholder: localField.placeholder || "Enter value",
      priority: localField.priority || 1,
      visibility: localField.visibility,
      place: localField.place,
    }));
    return updatedFields;
  });
  const customComponents = {
    DropdownIndicator: () => null,
  };

  useEffect(() => {
    console.log('Updated AddedProducts:', itemlist);
  }, [itemlist]);

  const nameoption = stonemaster.map(st => ({
    label: st.StoneName,
    value: st.Id
  }))
  const coloroption = stonemaster.map(st => ({
    label: st.StoneName,
    value: st.Id
  }))
  const shapeoption = stonemaster.map(st => ({
    label: st.StoneName,
    value: st.Id
  }))
  const sizeoption = stonemaster.map(st => ({
    label: st.StoneName,
    value: st.Id
  }))



  // Handle saving the updated stone details
  const handleSave = () => {
    const isValid = stoneDetails.every((stone, index) => {
      if (!stone.StoneName || !stone.StoneName.trim()) {
        alert(`Please add a StoneName for stone at position ${index + 1}.`);
        return false;
      }
      if (!stone.StoneWeight || parseFloat(stone.StoneWeight) <= 0) {
        alert(`Please add a valid StoneWeight for stone at position ${index + 1}.`);
        return false;
      }
      return true;
    });

    if (!isValid) {
      return; // Stop saving if validation fails
    }
    onSave(stoneDetails, 'stones'); // Pass updated stone details to the parent
    onClose(); // Close the popup after saving
  };


  // Add Keyboard Shortcut for Ctrl + S
  useEffect(() => {

    // if (inputRefs.current[currentFieldIndex]) {
    //     inputRefs.current[currentFieldIndex].focus();

    // }

    // const handleKeyDown = (e) => {
    //     if (e.key === 'Escape') {
    //         onClose();
    //     } else if (e.key === 'Enter') {
    //         console.log('check trigger ', currentFieldIndex, '   ', inputRefs.current.length);
    //             if (currentFieldIndex < inputRefs.current.length - 1) {
    //                 setCurrentFieldIndex(currentFieldIndex + 1);
    //             } else {
    //                 handleadditem();
    //             }

    //     } else if (e.key === 'ArrowLeft') {
    //         if (currentFieldIndex > 0) {
    //             setCurrentFieldIndex(currentFieldIndex - 1);
    //         }
    //     } else if (e.ctrlKey && e.key === 's') {
    //         e.preventDefault(); // Prevent browser's save dialog
    //         handleSave(); // Trigger save function
    //     }
    // };


    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const nextIndex = currentFieldIndex + 1;
        if (nextIndex < stoneDetails.length * itemfields.length) {
          setCurrentFieldIndex(nextIndex);
        } else {
          handleadditem(); // Add a new row
        }
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        if (currentFieldIndex > 0) {
          setCurrentFieldIndex(currentFieldIndex - 1);
        }
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        const nextIndex = currentFieldIndex + 1;
        if (nextIndex < stoneDetails.length * itemfields.length) {
          setCurrentFieldIndex(nextIndex);
        }
      } else if (e.key === "Escape") {
        onClose();
      } else if (e.ctrlKey && e.key === 's') {
        e.preventDefault(); // Prevent browser's save dialog
        handleSave(); // Trigger save function
      }
    };


    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentFieldIndex, onClose, handleSave]);


  useEffect(() => {
    const refKey = `${Math.floor(currentFieldIndex / itemfields.length)}-${itemfields[currentFieldIndex % itemfields.length].key}`;
    const inputElement = inputRefs.current[refKey];
    if (inputElement) {
      inputElement.focus();
    }
  }, [currentFieldIndex, itemfields]);





  // Get the stone details for the selected item
  const [stoneDetails, setStoneDetails] = useState(itemlist[index]?.Stones || []);



  const handleadditem = () => {
    const allWeightsValid = stoneDetails.every(
      (stone) => parseFloat(stone.StoneWeight) > 0
    );

    if (!allWeightsValid) {
      alert("Please ensure all stones have a valid weight before adding a new one.");
      return;
    }

    setStoneDetails((prevDetails) => [...prevDetails, addStone]);
    // setCurrentFieldIndex(0);

    const newFieldIndex = (stoneDetails.length) * itemfields.length;
    setCurrentFieldIndex(newFieldIndex);


  };

  const handleDeleteStone = (stoneIndex) => {
    setStoneDetails((prevDetails) =>
      prevDetails.filter((_, index) => index !== stoneIndex)
    );
  };

  const handlevaluechange = (e, stoneIndex, fieldKey) => {
    const value = e.target.value;
    const selectedStoneName = fieldKey === "StoneName" ? value : null;
    const selectedStone = stonemaster.find(stone => stone.Id === selectedStoneName);
    const grossWeight = parseFloat(itemlist[index]?.GrossWt) || 0;

    setStoneDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      const currentStone = updatedDetails[stoneIndex] || {};

      if (fieldKey === "StoneName" && selectedStone) {

        console.log('StoneRateKarate:', currentStone.StoneRateKarate);
        console.log('StoneRate:', currentStone.StoneRate);
        console.log('Selected Stone:', selectedStone);


        // Autofill other fields
        updatedDetails[stoneIndex] = {
          ...selectedStone, // Use properties from stonemaster
          StoneRateKarate: parseFloat(selectedStone.StoneRateKarate) || parseFloat(selectedStone.StoneRate) || 0,

          StoneRatePiece: selectedStone.StoneRatePiece || 0,
          StoneAmount: selectedStone.StoneAmount || 0,
        };
      } else if (fieldKey === "StoneRateKarate") {
        const ratePerCarat = parseFloat(value) || 0;
        // const amount = ratePerCarat * (currentStone.StoneWeight || 0);
        const amount = (ratePerCarat * (currentStone.StoneWeight || 0)).toFixed(2);

        updatedDetails[stoneIndex] = {
          ...currentStone,
          StoneRateKarate: ratePerCarat,
          StoneRatePiece: 0, // Disable rate per piece
          StoneAmount: amount,
        };
      } else if (fieldKey === "StoneRatePiece") {
        const ratePerPiece = parseFloat(value) || 0;

        // const amount = ratePerPiece * (currentStone.StonePieces || 0);

        const amount = (ratePerPiece * (currentStone.StonePieces || 0)).toFixed(2);


        updatedDetails[stoneIndex] = {
          ...currentStone,
          StoneRatePiece: ratePerPiece,
          StoneRateKarate: 0, // Disable rate per carat
          StoneAmount: amount,
        };
      } else if (fieldKey === "StoneWeight") {
        const rawWeight = e.target.value; // Get the raw input
        const newWeight = parseFloat(value);
        const totalWeight = updatedDetails.reduce(
          (sum, stone, idx) => sum + (idx === stoneIndex ? newWeight : parseFloat(stone.StoneWeight) || 0),
          0
        );

        if (totalWeight > grossWeight) {
          alert(`Total StoneWeight cannot exceed GrossWeight (${grossWeight}).`);
          return prevDetails; // Do not update state if validation fails
        }

        const weight = parseFloat(value);
        // const amount = weight * (currentStone.StoneRateKarate || 0);

        const amount = (newWeight * (currentStone.StoneRateKarate || 0)).toFixed(2);


        // Update weight if validation passes
        updatedDetails[stoneIndex] = {
          ...currentStone,
          StoneWeight: rawWeight,
          // StoneRateKarate: ratePerCarat,
          // StoneRatePiece: 0, // Disable rate per piece
          StoneAmount: amount,

          // [fieldKey]: value,
        };
      }
      else if (fieldKey === "StonePieces") {
        // const ratePerPiece = parseFloat(value) || 0;
        // const amount = ratePerPiece * (currentStone.StonePieces || 0);
        const pieces = parseFloat(value) || 0;

        // const rp = pieces * (currentStone.StoneRatePiece || 0);

        const amount = (pieces * (currentStone.StoneRatePiece || 0)).toFixed(2);


        updatedDetails[stoneIndex] = {
          ...currentStone,
          StonePieces: pieces,
          // StoneRatePiece: pieces,
          // StoneRateKarate: 0, // Disable rate per carat
          StoneAmount: amount,
        };
      }

      else {
        updatedDetails[stoneIndex] = {
          ...currentStone,
          [fieldKey]: value,
        };
      }

      console.log('check updatestone...', updatedDetails);

      return updatedDetails;
    });
  };

 

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <p style={{ fontSize: "14px", fontWeight: "bold" }}>
            Add Stone Details
          </p>
          <Icon
            style={{
              cursor: "pointer",
              fontSize: "20px",
              color: "#627282",
            }}
            icon="carbon:close-filled"
            onClick={onClose} // Close the modal
          />
        </div>
        <table className="diamond-table">
          <thead>
            <tr>
              {/* Render dynamically generated headers */}
              {itemfields
                .filter(field => field.place === 'top' && field.visibility !== 'Hidden' && field.IsVisible)
                .sort((a, b) => a.priority - b.priority)
                .map(field => (
                  <th key={field.key}>

                    {field.key === 'ActionPlus' ? (
                      <>
                        {/* Action */}
                        <FaPlus
                          style={{
                            marginLeft: '8px',
                            cursor: 'pointer',
                            height: '20px',
                            width: '20px',
                            color: '#4CAF50', // Customize icon color
                          }}
                          onClick={() => {
                            handleadditem()
                            // Add row functionality here
                          }}
                        />
                      </>
                    ) : (
                      field.label || field.key
                    )}
                  </th>
                ))}

            </tr>
          </thead>
          <tbody>
            {stoneDetails.map((stone, stoneIndex) => (
              <tr key={stoneIndex}>
                {itemfields
                  .filter(field => field.place === "top" && field.visibility !== "Hidden" && field.IsVisible)
                  .sort((a, b) => a.priority - b.priority)
                  .map((field, fieldIndex) => {
                    const value = stone[field.key] || ""; // Get value for this stone detail
                    console.log('stonefieldkey ', field.key);

                    return (

                      <td key={field.key}>
                        {field.type === "inputnumber" ||
                          field.type === "inputtext" ||
                          field.type === "inputdecimal" ? (
                          <input
                            type={
                              field.type === "inputnumber" || field.type === "inputdecimal"
                                ? "number"
                                : "text"
                            } // Use appropriate input type
                            step={field.type === "inputdecimal" ? "0.01" : "1"} // Handle decimal precision
                            value={value} // Bind input to normalized value
                            className="AddStock-input"
                            ref={(el) => {
                              const refKey = `${stoneIndex}-${field.key}`;
                              inputRefs.current[refKey] = el;
                            }}
                            onFocus={() => {
                              const fieldIndex = stoneIndex * itemfields.length + itemfields.findIndex(f => f.key === field.key);
                              setCurrentFieldIndex(fieldIndex); // Update to the correct field index
                            }}
                            // disabled={field.visibility}
                            onChange={(e) => handlevaluechange(e, stoneIndex, field.key)}
                          />
                        ) : field.type === "inputselect" ? (
                          <div key={field.key}>
                            <Select
                              // className="adminAddCategoryMainBox2-input"
                              className="basic-single"
                              components={customComponents}
                              // value={value}
                              value={nameoption.find(
                                (option) =>
                                  option.label === stone[field.key] // Match current value with options
                              )}
                              options={nameoption}
                              ref={(el) => {
                                const refKey = `${stoneIndex}-${field.key}`;
                                inputRefs.current[refKey] = el;
                              }}
                              onFocus={() => {
                                const fieldIndex = stoneIndex * itemfields.length + itemfields.findIndex(f => f.key === field.key);
                                setCurrentFieldIndex(fieldIndex); // Update to the correct field index
                              }}
                              onChange={(selectedOption) => handlevaluechange({ target: { value: selectedOption.value } }, stoneIndex, field.key)}
                            // onChange={(e) => handlevaluechange(e, stoneIndex, field.key)}
                            />

                          </div>
                        )
                          : field.type === "Icon" ? (
                            <div key={field.key}>
                              <FaTrash
                                style={{
                                  marginLeft: '8px',
                                  cursor: 'pointer',
                                  // color: '#4CAF50', // Customize icon color
                                }}
                                onClick={() => {
                                  handleDeleteStone(stoneIndex)
                                  // Add row functionality here
                                }}
                              />

                            </div>
                          ) : (
                            null
                          )}
                      </td>
                    );
                  })}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>

              {itemfields
                .filter(field => field.place === "top" && field.visibility !== "Hidden" && field.IsVisible)
                .sort((a, b) => a.priority - b.priority)
                .map(field => {

                  return (
                    <td key={field.key}>
                      {field.key === 'StoneWeight'
                        ? stoneDetails.reduce((total, stone) => total + parseFloat(stone.StoneWeight || 0), 0).toFixed(3)
                        : field.key === 'StonePieces'
                          ? stoneDetails.reduce((total, stone) => total + (parseInt(stone.StonePieces, 10) || 0), 0)
                          : field.key === 'StoneAmount'
                            ? stoneDetails.reduce((total, stone) => total + (parseFloat(stone.StoneAmount || 0) || 0), 0).toFixed(2)
                            : null}
                    </td>
                  )
                })}
            </tr>
          </tfoot>
        </table>
        <div className="modal-footer">
          <button onClick={handleSave} className="save-button">Save</button>
          <button onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default SingleStonePopUp;
